/** Arquivos da empresa (drive): o que o escritório guardou para o cliente, por pasta. */
import { createFileRoute } from '@tanstack/react-router';
import { ComPortal } from '../telas/portal/casca';
import { ArquivosEmpresa } from '../telas/portal/drive';

export const Route = createFileRoute('/portal/drive')({ component: () => <ComPortal>{(d) => <ArquivosEmpresa d={d} />}</ComPortal> });
